import React from "react";
import {StatusTag} from "../../../../common/status/status";
import {
    PropertyInventoryTaskPartStatus,
    PropertyInventoryTaskStatus,
    statusColor
} from "../../../../../models/property/property";

interface InventoryTaskStatusProps {
    status: PropertyInventoryTaskStatus | PropertyInventoryTaskPartStatus;
    large?: boolean;
}
export const InventoryTaskStatus: React.FC<InventoryTaskStatusProps> = ({status, large = false}) => {
    return (
        <StatusTag<PropertyInventoryTaskStatus | PropertyInventoryTaskPartStatus> status={status} colorsMap={statusColor} large={large} prefix="DOCUMENTS.STATUS"/>
    )
}
